import ListProformaSales from "../../../../components/@documents/proforma_sales/ListProformaSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ProformaSalesPage() {

    return (
        <ListProformaSales 
            routeType={routeTypes.admin}
        />
    )
}